import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { AuthUserService } from "../services/auth-user.service";
import { APP_ROUTES } from 'app/common/constants';
import { POST_LOGIN_REDIRECT_STORAGE_KEY } from '../auth/post-login-redirect';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private authService: AuthUserService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): boolean {
    if (!this.authService.isAuthenticated()) {
      if (state?.url) {
        sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, state.url);
      }
      this.router.navigate([APP_ROUTES.AUTH.NOT_APPROVED]);
      return false;
    }

    const requestedPath = (state.url || '');

    if (this.authService.IsDomainExcluded ||
        this.authService.hasAccessToPage(requestedPath)) {
      return true;
    } else {
      this.authService.navigateToDefaultOnRole()
      return false;
    }
  }
}
